<template>
  <div class="centerx" id="update-staff-service">
    <vs-popup class="checkout-staff-popup" title="Staff & Service" :active.sync="popupStaffDetail.isOpen">
      <vs-tabs style="background: #fff" class="staff-service-content">
        <vs-tab label="Staff">
          <div class="mt-6" style="max-height: calc(100vh - 300px); overflow-y: auto; padding: 20px" v-if="popupStaffDetail.item_info && popupStaffDetail.item_info.staffs">
            <!-- <vx-card class="mb-5 overflow-hidden md:p-0 p-5" v-for="(staff, index) in staffList" :key="index" :class="{'is-selected': staff.isInCurrentCheckin}">
              <template slot="no-body">
                  <div class="item-details no-gutter p-6 flex align-center">
                      <div class="contact__avatar mr-1">
                          <vs-avatar class="border-2 border-solid border-white" size="42px" :text="StringHelper.changeFormatAvatar(staff.name)" :color="staff.color_code"></vs-avatar>
                          <vs-avatar class="border-2 border-solid border-white" size="42px" :text="staffData.name"></vs-avatar>
                      </div>
                      <div class="w-11/12">{{staff.name}}</div>
                      <div class="1/12 ml-auto vs-component con-vs-checkbox vs-checkbox-primary vs-checkbox-default">
                          <input class="vs-checkbox--input" type="checkbox" v-model="checkBoxStaff" :user_id="staff.user_id" :value="staff.user_id" @change="onChangeStaff">
                          <span class="checkbox_x vs-checkbox">
                            <span class="vs-checkbox--check"><i class="vs-icon notranslate icon-scale vs-checkbox--icon  material-icons null">check</i></span>
                          </span>
                      </div>
                  </div>
              </template>
            </vx-card> -->
            <vx-card class="mb-5 overflow-hidden md:p-0 p-5 is-selected" v-for="(staff, index) in popupStaffDetail.item_info.staffs" :key="index">
              <div class="w-full p-6 flex justify-between">
                {{staff.name}}
                <feather-icon icon="CheckIcon" svgClasses="w-6 h-6 stroke-current text-primary" />
              </div>
              <!-- <div class="vs-component con-vs-checkbox vs-checkbox-primary vs-checkbox-default p-6">
                <span class="con-slot-label">
                  <div class="title ml-auto">{{staff.name}}</div>
                </span>
                <input type="checkbox" class="vs-checkbox--input" v-model="checkBoxStaff" :user_id="staff.user_id" :value="staff.user_id" @change="onChangeStaff">
                <span class="checkbox_x vs-checkbox ml-auto">
                  <span class="vs-checkbox--check"><i class="vs-icon notranslate icon-scale vs-checkbox--icon  material-icons null">check</i></span>
                </span>
              </div> -->
            </vx-card>
            <!-- <div v-if="staffData._meta.pageCount">
              <vs-pagination class="mt-6 custom-pagination" :total="parseInt(staffData._meta.pageCount)" v-model="currentPageStaff" @click.native="changePageStaff(currentPageStaff, itemsPerPageStaff)"></vs-pagination>
            </div> -->
          </div>
        </vs-tab>
        <vs-tab label="Service">
           <div class="mt-6" style="max-height: calc(100vh - 280px); overflow-y: auto; padding: 20px" v-if="popupStaffDetail.item_info && popupStaffDetail.item_info.services">
            <!-- <vx-card class="mb-5 overflow-hidden md:p-0 p-5" v-for="(service, index) in serviceList" :key="index" :class="{'is-selected': isChosenService(service)}">
              <template slot="no-body">
                  <div class="item-details no-gutter p-6 flex align-center">
                      <div class="w-11/12">{{service.name}}</div>
                      <div class="1/12 ml-auto vs-component con-vs-checkbox vs-checkbox-primary vs-checkbox-default">
                          <input class="vs-checkbox--input" type="checkbox" v-model="checkBoxService" :id="service.id" :value="service.id" @change="onChangeService">
                          <span class="checkbox_x vs-checkbox">
                            <span class="vs-checkbox--check"><i class="vs-icon notranslate icon-scale vs-checkbox--icon  material-icons null">check</i></span>
                          </span>
                      </div>
                  </div>
              </template>
            </vx-card> -->
            <!-- <vx-card class="mb-5 overflow-hidden md:p-0 p-5" v-for="(service, index) in serviceList" :key="index" :class="{'is-selected': isChosenService(service)}">
              <div class="vs-component con-vs-checkbox vs-checkbox-primary vs-checkbox-default p-6">
                <span class="con-slot-label">
                  <div class="title ml-auto">{{service.name}}</div>
                </span>
                <input type="checkbox" class="vs-checkbox--input" v-model="checkBoxService" :id="service.id" :value="service.id" @change="onChangeService">
                <span class="checkbox_x vs-checkbox ml-auto">
                  <span class="vs-checkbox--check"><i class="vs-icon notranslate icon-scale vs-checkbox--icon  material-icons null">check</i></span>
                </span>
              </div>
            </vx-card>
            <div v-if="serviceData._meta.pageCount">
              <vs-pagination class="mt-6 custom-pagination" :total="parseInt(serviceData._meta.pageCount)" v-model="currentPage" @click.native="changePage(currentPage, itemsPerPage)"></vs-pagination>
            </div> -->
            <vx-card class="mb-5 overflow-hidden md:p-0 p-5 is-selected" v-for="(service, index) in popupStaffDetail.item_info.services" :key="index">
              <div class="w-full p-6 flex justify-between">
                {{service.name}}
                <feather-icon icon="CheckIcon" svgClasses="w-6 h-6 stroke-current text-primary" />
              </div>
            </vx-card>
          </div>
        </vs-tab>
      </vs-tabs>
    </vs-popup>
  </div>
</template>

<script>
import { StringHelper } from "../../models/string_helper";
    export default {
        name: "vs-popup-staff-service-detail",
        components: {
            ListItem: () => import("./ListItem.vue"),
            ListRadioItem: () => import("./ListRadioItem.vue"),
        },
        props: {
            popupStaffDetail: {
                type: Object,
                required: true
            }
        },
        data() {
          // console.log(this.popupStaffDetail);
          // if(this.popupStaffDetail && this.popupStaffDetail.staffs) {
          //   this.$store.dispatch('staffList/GET_CHECKIN_STAFF', this.popupStaffDetail.staffs);
          // }
          return {
            StringHelper,
            currentPage: 1,
            itemsPerPage: 10,
            currentPageStaff: 1,
            itemsPerPageStaff: 10,
              note: '',
              promotion: '',
              redemption_list: [
                  {title: '3pts',   content: '$1 off for 3 points', checked: undefined },
                  {title: '100pts', content: '$5 off for 100 points', checked: undefined },
                  {title: '300pts', content: '$10 off for 300 points', checked: undefined },
                  {title: '500pts',   content: '500 points you can get free 30$', checked: undefined },
              ],
              promotion_list: [
                  {title: '3pts',   content: '$1 off for 3 points' },
                  {title: '100pts', content: '$5 off for 100 points' },
                  {title: '300pts', content: '$10 off for 300 points' },
                  {title: '500pts',   content: '500 points you can get free 30$' },
              ],
              checkBoxStaff : [],
              checkBoxService : [],
          }
        },
        methods: {
          isChosenStaff(staff) {
            if(this.popupStaffDetail && this.popupStaffDetail.staffs) {
              for(let i = 0; i < this.popupStaffDetail.staffs.length; i++) {
                if(this.popupStaffDetail.staffs[i].user_id == staff.user_id) {
                  return true;
                }
              }
            }
            return false;
          },
          isChosenService(service) {
            if(this.popupStaffDetail && this.popupStaffDetail.services) {
              for(let i = 0; i < this.popupStaffDetail.services.length; i++) {
                if(this.popupStaffDetail.services[i].user_id == service.user_id) {
                  return true;
                }
              }
            }
            return false;
          },
            changePage(currentPage, itemsPerPage) {
                const obj = {
                    page: currentPage,
                    "per-page": itemsPerPage,
                }
                this.$store.dispatch("serviceList/GET_SERVICE_LIST", obj)
            },
            changePageStaff(currentPageStaff, itemsPerPageStaff) {
                const obj = {
                    page: currentPageStaff,
                    "per-page": itemsPerPageStaff,
                }
                this.$store.dispatch("staffList/GET_STAFF_LIST", obj)
            },
            getMemberTypeColor(member_type) {
                if (member_type == "new") return "success";
                if (member_type == "regular") return "primary";
                if (member_type == "vip") return "danger";
                return "dark";
            },
            openLoadingInDiv(){
              this.$vs.loading({
                container: '#update-staff-service',
                scale: 0.8
              })
            },
            closeLoading() {
              this.$vs.loading.close('#update-staff-service > .con-vs-loading');
            },
            check: function(e) {
              if (e.checked) {
                console.log(e.value)
              }
            },
            selectId(e) {
              this.selectedId = e.user_id
              this.checkBoxStaff.push(this.selectedId)
            },
            onChangeStaff(){
              this.openLoadingInDiv();
              const obj = {
                checkin_id: this.popupStaffDetail.item_info.id,
                staffs: String(this.checkBoxStaff),
              }
              this.$store.dispatch("checkin/UPDATE_STAFF",obj).then(() => {
                this.closeLoading();
                this.$vs.notify({
                  title:'Notification',
                  text:'Update Staff Success',
                  color:'success',
                  position:'top-right'});
              })
            },
            onChangeService(){
              this.openLoadingInDiv();
              const obj = {
                checkin_id: this.popupStaffDetail.item_info.id,
                services: String(this.checkBoxService),
              }
              this.$store.dispatch("checkin/UPDATE_SERVICE",obj).then(() => {
                this.closeLoading();
                this.$vs.notify({
                  title:'Notification',
                  text:'Update Service Success',
                  color:'success',
                  position:'top-right'});
              })
            }
        },
        watch:{
          popupStaffDetail: {
            immediate: true,
            deep: true,
            handler() {
              if(this.popupStaffDetail.isOpen) {
                document.body.classList.add('overflow-hidden');
                document.body.style.position = '';
                document.body.style.top = '';
                window.scrollTo(0, parseInt(scrollY || '0') * -1);
              } else {
                document.body.classList.remove('overflow-hidden');
              }
            }
          }
        },
        computed:{
          checkout_info(){
            return this.$store.state.checkin.checkoutInfo;
          },
          staffData(){
            return this.$store.state.staffList.staffData;
          },
          serviceData(){
            return this.$store.state.serviceList.checkoutServiceData;
          },
          staffList(){
            return this.$store.state.staffList.staffList;
          },
          serviceList(){
            return this.$store.state.serviceList.checkoutService;
          }
        },
        created(){
         if(this.popupStaffDetail.item_info != null){
            const obj = {
              page: 1,
              "per-page": 10
            }
            const data = {
              page: 1,
              "per-page" : 10,
            }
            this.$store.dispatch("staffList/GET_STAFF_LIST",obj).then(() => {
              let staffList = this.popupStaffDetail.item_info.staffs;
              if(staffList){
                for(let i=0 ; i<staffList.length;i++){
                  this.checkBoxStaff.push(staffList[i].user_id)
                }
              }
            })
            this.$store.dispatch("serviceList/GET_SERVICE_LIST",data).then(() => {
              let serviceList = this.popupStaffDetail.item_info.services;
              if(serviceList){
                for(let i=0 ; i<serviceList.length;i++){
                  this.checkBoxService.push(serviceList[i].id)
                }
              }
            })
          }
        }
    };
</script>

<style lang="scss">
@import '@/assets/scss/vuexy/_variables';
#update-staff-service {
  .vs-checkbox--input {
    left: 0;
  }
  .vs-checkbox {
    border: 2px solid rgb(180, 180, 180);
  }
}
.is-selected {
      -webkit-transform: translate(0)!important;
      transform: translate(0)!important;
      background: rgba($primary,.05)!important;
  }

  .is-selected {
      color: rgba($primary,1);
      -webkit-box-shadow: 0 0 1px 0 rgba($primary,1)!important;
      box-shadow: 0 0 1px 0 rgba($primary,1)!important;
  }
.checkout-staff-popup {
  .vx-card__body {
      padding: 0 !important;
    }
}
.custom-col {
    width: calc(100% / 3);
}

.con-vs-popup .vs-button {
    min-width: unset !important;
}

// @media (max-width: 991px) {
//     .custom-col {
//         width: 100%;
//     }
// }
.con-vs-popup {
        &.checkout-staff-popup {
            z-index: 90000 !important;
           .vs-popup {
                width: 600px;
                height: auto;
                .vs-popup--content {
                    width: auto;
                    height: calc(100vh - 200px);

                    // max-height: calc(100vh - 200px);
                    // min-height: calc(100vh - 600px);
                    margin-right: 0;
                    .bg-custom {
                      background: #fafafa;
                    }
                }
           }
        }
    }
.theme-dark {
  .con-vs-popup {
        &.checkout-staff-popup {
          .vs-popup {
                .vs-popup--content {
                  .bg-custom {
                    background: transparent !important;
                  }
                }
          }
        }
  }
}
.staff-service-content {
        max-height: calc(100vh - 230px);
        // overflow-y: auto;
        // &.customer {
        //     max-height: calc(100vh - 250px);
        // }
        .vs-tab {
            box-shadow: 0 0 8px 4px rgba(0, 0, 0, 0.4);
        }
        .vs-tabs--li {
            width: 50% !important;
        }
        .line-vs-tabs {
            width: calc(100% / 2) !important;
        }
    }
</style>
